import axios from 'axios';
import { baseUrl } from '../settings';
import authHeader from './auth-header';

const API_URL = baseUrl + '/file/';

class FileService {
  getUserFiles(page) {
    return axios.post(API_URL + 'userFileList?page=' + page, null, { headers: authHeader() });
  }

  checkIsFileExist(fileIds) {
    var formData = new FormData();
    formData.append("file_ids", fileIds);

    return axios.post(API_URL + 'checkFileExists', formData, { headers: authHeader() });
  }

  downloadTracker(data, isOriginal) {
    data.is_original = isOriginal;
    if(authHeader() !== null)
    {
      return axios.post(API_URL + 'user-file-download', data, { headers: 
        authHeader()  });
    }else{
      return axios.post(API_URL + 'file-download', data);
    }
  }
}

export default new FileService();